export * from "-!../../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./modal.vue?vue&type=template&id=b1da2c84"


//////////////////
// WEBPACK FOOTER
// ./skins/bulmasite/components/common/mbk/modal.vue?vue&type=template&id=b1da2c84
// module id = yPK3
// module chunks = 0